import dayjs from "dayjs";
import { CorpReservation, HotelBookAgainSourceEnum, LodgingSelectionEnum, Reservation } from "redmond";
import {
  PARAM_LODGING_ID,
  PARAM_ADULTS_COUNT,
  PARAM_ROOMS_COUNT,
  PARAM_LODGING_SELECTION,
  PARAM_FROM_DATE,
  PARAM_UNTIL_DATE,
  LODGING_SELECTION_TYPE,
  LODGING_IDS,
  PRESERVE_ORDER,
} from "../../../hotels-module/src/utils/queryParamConstants";
import { PATH_SHOP } from "../../../hotels-module/src/utils/paths";

const PARAM_ENTRY_POINT = "entryPoint";

const getEntryTypeFromSource = (source: HotelBookAgainSourceEnum) => {
  switch (source) {
    case HotelBookAgainSourceEnum.MyTrips:
      return "book_again_hotel_mytrips"
    case HotelBookAgainSourceEnum.Confirmation:
      return "book_again_hotel_confirmation_page"
    default:
      return null
  }
}

export const getBookAgainUrl = (
  reservation: Reservation | CorpReservation,
  source: HotelBookAgainSourceEnum,
): string => {
  const today = dayjs();
  const originalCheckIn = reservation.checkInDate
    ? dayjs(reservation.checkInDate)
    : null;
  const originalCheckOut = reservation.checkOutDate
    ? dayjs(reservation.checkOutDate)
    : null;
  const areDatesInFuture =
    originalCheckIn && originalCheckOut && originalCheckIn.isAfter(today);

  const searchParams = new URLSearchParams();
  searchParams.set(PARAM_LODGING_ID, reservation.lodgingData.id);
  searchParams.set(PARAM_ADULTS_COUNT, "1");
  searchParams.set(PARAM_ROOMS_COUNT, "1");

  const entryType = getEntryTypeFromSource(source);
  if (entryType !== null) {
    searchParams.set(PARAM_ENTRY_POINT, entryType);
  }

  const lodgingSelection = {
    [LODGING_SELECTION_TYPE]: LodgingSelectionEnum.LodgingIds,
    [LODGING_IDS]: [reservation.lodgingData.id],
    [PRESERVE_ORDER]: true,
  };
  searchParams.set(
    PARAM_LODGING_SELECTION,
    encodeURIComponent(JSON.stringify(lodgingSelection))
  );

  if (areDatesInFuture) {
    searchParams.set(PARAM_FROM_DATE, originalCheckIn.format("YYYY-MM-DD"));
    searchParams.set(PARAM_UNTIL_DATE, originalCheckOut.format("YYYY-MM-DD"));
  }

  return `${PATH_SHOP}?${searchParams.toString()}`;
};
